export class Lyte
{
    constructor()
    {
        this._paq = window._paq = window._paq || [];
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        this._paq.push(['disableCookies']);
        this._paq.push(['trackPageView']);
        (function() {
            var u="//lyte.aheadware.com/";
            _paq.push(['setTrackerUrl', u+'matomo.php']);
            _paq.push(['setSiteId', '2']);
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
        })();
    }

    trackPageView( title = null )
    {
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
        {
            return;
        }
        this._paq.push(['setCustomUrl', '/' + window.location.pathname ]);
        this._paq.push(['setDocumentTitle', title ? title : window.location.pathname ] );
        this._paq.push(['trackPageView']);
    }

    trackEvent( name, detail )
    {
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
        {
            return;
        }
        this._paq.push(['trackEvent', name, detail]);
    }
}
